module.exports = __webpack_public_path__ + "img/environment_img.ec3063db.png";